/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FormRowTypes {
    Base = '0',
    Repeatable = 1,
    Single = 2,
}
